import React from 'react'
import { useRouter } from 'next/router'
import * as Yup from 'yup'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import SelectChecklist from 'components/SelectChecklist'

import FormsStore from 'stores/forms'
import { useStore } from 'hooks'

const WagerAmountSchema = Yup.object().shape({
  wager_amount: Yup.string().trim().min(1, 'First Name should be non-empty').required('Field is required')
})

const wagerAmountOptions = [
  {
    value: '1-10',
    label: '$1 - $10'
  },
  {
    value: '11-50',
    label: '$11 - $50'
  },
  {
    value: '51-200',
    label: '$51 - $200'
  },
  {
    value: '200-500',
    label: '$200 - $500'
  },
  {
    value: '500-1000',
    label: '$500 - $1,000'
  },
  {
    value: '1000+',
    label: 'Over $1,000'
  }
]

const WagerAmountForm = () => {
  const router = useRouter()
  const formsStore = useStore(FormsStore)
  const handleSubmit = ({ wager_amount }) => {
    // add info to the forms store somehow
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What is your average wager when betting on sports?',
      answer: wager_amount
    })

    router.push('/barstool-sportsbook/favorite-sports')
  }
  return (
    <Formik
      initialValues={{
        wager_amount: ''
      }}
      validationSchema={WagerAmountSchema}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize={true}
      onSubmit={handleSubmit}
    >
      {({ values }) => (
        <Form className='sportsBookForm'>
          <Field name='wager_amount'>
            {({ field, form }) => <SelectChecklist {...field} {...form} options={wagerAmountOptions} />}
          </Field>
          <ErrorMessage name='wager_amount' component='div' className='field__error' />
          <button
            type='submit'
            className={`sportsBook__submitButton${!values?.wager_amount ? '--disabled' : ''}`}
            disabled={!values?.wager_amount}
          >
            Continue
          </button>
        </Form>
      )}
    </Formik>
  )
}

export default WagerAmountForm
